// Header component -- contains View Menu
import React from 'react';
// Components
import ViewMenu from './ViewMenu';
// UI
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import logo from '../../img/logo.png';
import Button from "@material-ui/core/Button";
import domtoimage from 'dom-to-image';
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';


// const pxToMm = (px) => {
// 	return Math.floor(px / document.getElementById('myMm').offsetHeight);
// };

// const mmToPx = (mm) => {
// 	return document.getElementById('myMm').offsetHeight * mm;
// };

// const range = (start, end) => {
// 	return Array(end - start).join(0).split(0).map(function (val, id) { return id + start });
// };

const useStyles = makeStyles(theme => ({
	root: {
		flexGrow: 1,
		backgroundColor: 'rgb(20,20,20)'
	},
	menuButton: {
		marginRight: theme.spacing(2)
	},
	title: {
		flexGrow: 1
	},
	appBar: {
		backgroundColor: 'rgb(20,20,20)'
	},
	toolBar: {
		display: 'flex',
		justifyContent: 'space-between'
	}
}));

export const Navbar = () => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<AppBar position="fixed" className={classes.appBar}>
				<Toolbar className={classes.toolBar}>
					<a href=''><img src={logo} alt="Gauge" id="headerLogo" /></a>

					<div style={{ display: 'flex', alignItems: 'center' }}>
						<Button
							style={{ marginRight: '25px', background: 'white' }}
							onClick={() => {
								domtoimage.toJpeg(document.getElementById('page-content'))
									.then(function (dataUrl) {
										var link = document.createElement('a');
										link.download = 'gauge.jpeg';
										link.href = dataUrl;
										link.click();
									});
							}}
						>
							Export Page as jpeg
						</Button>
						{/* <div
							className="pa2 ba bw1 b--black bg-yellow black-90 br2 dib pointer dim shadow-1"
							onClick={() => {
								const input = document.getElementById('barchart');
								const inputHeightMm = pxToMm(input.offsetHeight);
								const a4WidthMm = 1080;
								const a4HeightMm = 297;
								const a4HeightPx = mmToPx(a4HeightMm);
								const numPages = inputHeightMm <= a4HeightMm ? 1 : Math.floor(inputHeightMm / a4HeightMm) + 1;
								console.log({
									input, inputHeightMm, a4HeightMm, a4HeightPx, numPages, range: range(0, numPages),
									comp: inputHeightMm <= a4HeightMm, inputHeightPx: input.offsetHeight
								});


								html2canvas(input)
									.then((canvas) => {
										const imgData = canvas.toDataURL('image/png');

										// Document of a4WidthMm wide and inputHeightMm high
										if (inputHeightMm > a4HeightMm) {
											// elongated a4 (system print dialog will handle page breaks)
											const pdf = new jsPDF('p', 'mm', [inputHeightMm + 16, a4WidthMm]);
											pdf.addImage(imgData, 'PNG', 0, 0);
											pdf.save(`gauge.pdf`);
										} else {
											// standard a4
											const pdf = new jsPDF();
											pdf.addImage(imgData, 'PNG', 0, 0);
											pdf.save(`gauge.pdf`);
										}


									});
								;

							}}
						>
							Export Page as PDF
					</div> */}
						<ViewMenu />
					</div>

				</Toolbar>
			</AppBar>
		</div>
	);
};

export default Navbar;
